// Reserved for minimal logic that triggers "above the fold"

function setGlobalVariables() {
  window.config = window.config || {}

  document.body.style.setProperty('--initial-height', `${window.innerHeight}px`)

  window.addEventListener('resize', updateGlobalVariables)
  updateGlobalVariables()
  observeHeaderResize()
}

function observeHeaderResize() {
  const element = document.querySelector('.section-header')

  const resizeObserver = new ResizeObserver((entries) => {
    for (let entry of entries) {
      updateGlobalVariables()
    }
  })

  resizeObserver.observe(element)
}

function updateGlobalVariables() {
  // Used for things like popups, drawers, etc. that need to be constrained within the viewable portion of a scroll-locked window
  document.body.style.setProperty('--inner-height', `${window.innerHeight}px`)

  setHeight({ selector: '.section-header', variable: 'navHeight', property: '--nav-height' })
  setHeight({ selector: '.section-announcement-bar', variable: 'barHeight', property: '--bar-height' })
}

function setHeight({ selector, variable, property }) {
  const element = document.querySelector(selector)

  if (element !== null) {
    window.config[variable] = element.offsetHeight
  } else {
    window.config[variable] = 0
  }

  document.body.style.setProperty(property, `${window.config[variable]}px`)
}

setGlobalVariables();

document.addEventListener('DOMContentLoaded', function() {
  const searchButton = document.querySelector('[data-toggle="#nav-desktop-search"]');
  const searchWrapper = document.querySelector('#nav-desktop-search');
  
  if (searchButton && searchWrapper) {
    // Listen for the toggle event
    searchButton.addEventListener('click', function() {
      // Check if search is currently expanded
      const isExpanded = searchButton.getAttribute('aria-expanded') === 'true';
      
      // Toggle the aria-expanded state
      searchButton.setAttribute('aria-expanded', !isExpanded);
      
      // Update the aria-label for better UX
      if (!isExpanded) {
        searchButton.setAttribute('aria-label', 'Close search');
      } else {
        searchButton.setAttribute('aria-label', 'Open search');
      }
    });
    
    // Optional: Listen for clicks outside to close search
    document.addEventListener('click', function(event) {
      if (!searchButton.contains(event.target) && !searchWrapper.contains(event.target)) {
        searchButton.setAttribute('aria-expanded', 'false');
        searchButton.setAttribute('aria-label', 'Open search');
      }
    });
    
    // Optional: Listen for Escape key to close search
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && searchButton.getAttribute('aria-expanded') === 'true') {
        searchButton.setAttribute('aria-expanded', 'false');
        searchButton.setAttribute('aria-label', 'Open search');
        // Focus back on the search button
        searchButton.focus();
      }
    });
  }
});


//empty the alt attribute of decorative images
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('img.social-trigger').forEach(img => {
    img.setAttribute('alt', '');
  });
});

//update account page titles
if (window.location.pathname === '/account/login') {
  function waitForElement(selector, timeout = 3000) {
    return new Promise((resolve, reject) => {
      const el = document.querySelector(selector);
      if (el) return resolve(el);

      const observer = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) {
          observer.disconnect();
          resolve(el);
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(() => {
        observer.disconnect();
        reject(new Error(`Timeout waiting for ${selector}`));
      }, timeout);
    });
  }

  waitForElement('[data-hook="account-template"]')
    .then((parent) => {
      console.log('parent found:', parent);
      const BASE_TITLE = 'Made Good Foods';

      const updateTitle = () => {
        const section = parent.querySelector('[data-page-title]');
        if (section) {
          const title = section.getAttribute('data-page-title');
          if (title) {
            document.title = title + ' | ' + BASE_TITLE;
          }
        }
      };

      updateTitle();

      const observer = new MutationObserver(updateTitle);
      observer.observe(parent, { childList: true, subtree: true });
    })
    .catch(console.warn);
}